import { memo } from 'react';

import { AlertBanner } from '@air/primitive-alert-banner';

import { useAccountProvisionerContext } from '~/components/AccountProvisioner/providers/AccountProvisionerProvider';

export const AccountProvisionBanner = memo(() => {
  const { accountProvisioner, hasError } = useAccountProvisionerContext();

  if (!accountProvisioner || !hasError) {
    return null;
  }

  return (
    <AlertBanner color="red">
      We encountered an issue while attempting to access your organization&apos;s workspaces. This could be due to a
      temporary system problem or an access-related issue. If it persists please contact your administrator.
    </AlertBanner>
  );
});

AccountProvisionBanner.displayName = 'AccountProvisionBanner';
